export class ComuniDto {
  public IdComune : number = 0;
  public CAP : string = '';
  public ComuneNascita : string = '';
  public ComuneDescrizione : string = '';
  public CodiceCF : string = '';
  public IdNazione : number = 0;
  public Cessato : boolean = false;
  public IdComuneMaster : number = 0;
  public CodiceIstat : string = '';
  public CodiceASL : string = '';
  public Coordinate : string = '';
  public IsComuneGenerico : boolean = false;
  public IdProvincia : number = 0;
  public IdRegione : number = 0;
}

export class NazioniDto {
  public IdNazione : number = 0;
  public NazioneNome : string = "";
}


export class Provincia{
  public IdProvincia : number = 0;
  public InizialiProvincia : string = "";
  public ProvinciaNome : string = "";
  public Stato : number = 0;
  public IdRegione : number = 0;
}

export class Regione{
  public IdRegione : number = 0;
  public RegioneNome : string = "";
  public Stato : number = 0;
}
